import { useMemo } from 'react';

// 获取健康 [颜色, 文字]
export default function useHealthColor(chartPercent) {
  const status = useMemo(() => {
    let label = '好';
    let color = 'rgba(16, 184, 128, 0.9)';
    if (chartPercent < 0.85) {
      color = 'rgba(244, 157, 11, .9)';
      label = '较差';
    }
    if (chartPercent < 0.15) {
      color = 'rgba(238, 68, 68, 0.9)';
      label = '极差';
    }
    return [color, label];
  }, [chartPercent]);
  return status;
}
